export default "__VITE_ASSET__8a65f5b0__"